import LegacyContentLoader from '@/components/LegacyContentLoader.vue'
import { routerErrorHandler } from '@/global-error-handler'
import NotFound from '@/NotFound.vue'
import { validateSession } from '@/utils/axios-client'
import AppFallback from '@/views/AppFallback.vue'
import AppFallbackBE from '@/views/AppFallbackBE.vue'
import AppFallbackNL from '@/views/AppFallbackNL.vue'
import ChangePassword from '@/views/ChangePassword.vue'
import Customer from '@/views/Customer.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import FormWizard from '@/views/FormWizard.vue'
import IopFormfailures from '@/views/IopFormfailures.vue'
import IopFormOverview from '@/views/IopFormOverview.vue'
import Layout from '@/views/Layout.vue'
import LegacyMain from '@/views/legacy/LegacyMain.vue'
import Login from '@/views/Login.vue'
import OrganisationDetails from '@/views/OrganisationDetails.vue'
import OrganisationOverview from '@/views/OrganisationOverview.vue'
import ProcessSsoLogin from '@/views/ProcessSsoLogin.vue'
import ProjectDetails from '@/views/ProjectDetails.vue'
import ProjectList from '@/views/ProjectList.vue'
import ShipmentOverview from '@/views/ShipmentOverview.vue'
import ShipmentTemplate from '@/views/ShipmentTemplate.vue'
import ShipmentTemplateOverview from '@/views/ShipmentTemplateOverview.vue'
import SubAppDetails from '@/views/SubAppDetails.vue'
import SubAppList from '@/views/SubAppList.vue'
import UserDetails from '@/views/UserDetails.vue'
import UsersOverview from '@/views/UsersOverview.vue'
import {
  createRouter,
  createWebHistory,
  type RouteLocationNormalized,
  type RouteLocationNormalizedGeneric,
  type RouteLocationNormalizedLoaded,
  type RouteRecordRaw,
} from 'vue-router'

declare module 'vue-router' {
  interface RouteMeta {
    title?: string | ((route: RouteLocationNormalizedLoaded) => string)
    breadcrumbParent?: string | ((route: RouteLocationNormalizedLoaded) => string)
    dynamicTitle?: boolean
    requiresAuth?: boolean
  }
}

const legacyRoutes = [
  // Projects
  {
    path: 'project/active-ecmr-projects',
    name: 'active-ecmr-projects',
    component: LegacyContentLoader,
    props: { url: '/ecmr/web/page/active-projects-ecmr' },
    meta: { title: 'eCMR Projecten' },
  },
  {
    path: 'project/ecmr-formulieren',
    name: 'ecmr-formulieren',
    component: LegacyContentLoader,
    props: { url: '/ecmr/web/page/ecmr-formulieren', scripts: ['ecmr-formulieren'] },
    meta: { title: 'eCMR Formulieren' },
  },
  {
    path: 'project/ecmr-rapportage',
    name: 'ecmr-rapportage',
    component: LegacyContentLoader,
    props: {
      url: '/ecmr/web/page/ecmr-rapportage-overview?submodule=ecmr-rapportage',
      scripts: ['ecmr-rapportage'],
    },
    meta: { title: 'Ritten' },
  },
  {
    path: 'project/active-projects',
    name: 'active-projects',
    component: LegacyContentLoader,
    props: { url: '/web/page/active-projects' },
    meta: { title: 'Actieve projecten' },
  },
  {
    path: 'project/active-projects-deellocatie',
    name: 'active-projects-deellocatie',
    component: LegacyContentLoader,
    props: { url: '/web/page/active-projects-deellocatie' },
    meta: { title: 'Actieve projecten' },
  },
  {
    path: 'project/formulieren',
    name: 'formulieren',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/formulieren' },
    meta: { title: 'Formulieren' },
  },
  {
    path: 'project/active-projects-lite',
    name: 'active-projects-lite',
    component: LegacyContentLoader,
    props: { url: '/web/page/active-projects-lite' },
    meta: { title: 'Actieve projecten' },
  },
  {
    path: 'project/active-projects-no-product-idf',
    name: 'active-projects-no-product-idf',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/active-projects-no-product-idf' },
    meta: { title: 'Actieve projecten' },
  },
  {
    path: 'project/active-projects-no-product-idf-grondbank',
    name: 'active-projects-no-product-idf-grondbank',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/active-projects-no-product-idf-grondbank' },
    meta: { title: 'Actieve projecten' },
  },
  {
    path: 'project/active-projects-no-vervoerder-idf-grondbank',
    name: 'active-projects-no-vervoerder-idf-grondbank',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/active-projects-no-vervoerder-idf-grondbank' },
    meta: { title: 'Actieve projecten' },
  },
  {
    path: 'project/active-projects-schip',
    name: 'active-projects-schip',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/active-projects-schip' },
    meta: { title: 'Actieve projecten' },
  },
  {
    path: 'project/rapportage',
    name: 'rapportage',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/rapportage' },
    meta: { title: 'Ritten' },
  },
  {
    path: 'project/rapportage-relation',
    name: 'rapportage-relation',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/relatie-rapportage' },
    meta: { title: 'Rapportage (relatie)' },
  },
  {
    path: 'project/rapportage-no-carrier',
    name: 'rapportage-no-carrier',
    component: LegacyContentLoader,
    props: {
      url: '/idf/web/page/no-vervoerder-idf-rapportage',
    },
    meta: {
      title: 'Ritten (no carrier)',
    },
  },
  {
    path: 'project/ship-reports',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/rapportage-overview-new' },
    meta: { title: 'Ritten & Vaarten' },
    name: 'ship-reports',
  },
  {
    path: 'project/rapportage-v2',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/rapportage-overview-new' },
    meta: { title: 'Rapportage' },
    name: 'rapportage-v2',
  },
  {
    path: 'project/rapportage-intern',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/rapportage-overview-new' },
    meta: { title: 'Rapportage' },
    name: 'rapportage-intern',
  },

  // Beheer
  {
    path: 'control/accounts',
    name: 'control-accounts',
    component: LegacyContentLoader,
    props: { url: '/auth/web/page/account-view' },
    meta: { title: 'Accounts' },
  },
  {
    path: 'control/new-client',
    name: 'control-new-client',
    component: LegacyContentLoader,
    props: { url: '/auth/web/page/new-client' },
    meta: { title: 'New Client' },
  },
  {
    path: 'control/ecmr-products',
    name: 'control-ecmr-products',
    component: LegacyContentLoader,
    props: { url: '/ecmr/web/page/ecmr-products' },
    meta: { title: 'eCMR Producten' },
  },
  {
    path: 'control/products',
    name: 'control-products',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/products' },
    meta: { title: 'Producten' },
  },
  {
    path: 'control/archived-projects',
    name: 'control-archived-projects',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/archived-projects' },
    meta: { title: 'Gearchiveerde Projecten' },
  },
  {
    path: 'control/app-registrations',
    name: 'control-app-registrations',
    component: LegacyContentLoader,
    props: (route: RouteLocationNormalized) => {
      const uuid = route.query['activateRegistration']
      return {
        url:
          '/idf/web/page/registered-apps' +
          (uuid ? `?activateRegistration=${encodeURIComponent(String(uuid))}` : ''),
      }
    },
    meta: { title: 'App Aanmeldingen' },
  },
  {
    path: 'control/organizations',
    name: 'control-organizations',
    component: LegacyContentLoader,
    props: { url: '/web/page/organisaties' },
    meta: { title: 'Organisaties' },
  },
  {
    path: 'control/relations',
    name: 'control-relations',
    component: LegacyContentLoader,
    props: { url: '/web/page/relaties' },
    meta: { title: 'Relaties' },
  },
  {
    path: 'control/relation/:uuid',
    name: 'control-relation-details',
    component: LegacyContentLoader,
    props: { url: '/web/page/relatie' },
    meta: { title: 'Relatie', breadcrumbParent: 'control-relations' },
  },

  {
    path: '/iop/beheer',
    component: { render: () => null },
    beforeEnter(to: RouteLocationNormalizedGeneric) {
      return `/home${to.fullPath}`
    },
  },
  {
    path: '/iop/berichten',
    component: { render: () => null },
    beforeEnter(to: RouteLocationNormalizedGeneric) {
      return `/home${to.fullPath}`
    },
  },
  {
    path: '/iop/failures',
    component: { render: () => null },
    beforeEnter(to: RouteLocationNormalizedGeneric) {
      return `/home${to.fullPath}`
    },
  },
  {
    path: 'iop/beheer',
    name: 'iop-beheer',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/iop/manageIopConnection' },
    meta: { title: 'Beheer iop connectie' },
  },
  {
    path: 'iop/berichten',
    name: 'iop-berichten',
    component: IopFormOverview,
    meta: { title: 'Berichten van het iop' },
  },
  {
    path: 'iop/failures',
    name: 'iop-failures',
    component: IopFormfailures,
    meta: { title: 'Forms failed to process' },
  },

  // Extern
  {
    path: 'external/home',
    name: 'external-home',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/audit-home' },
    meta: { title: 'Home' },
  },
  {
    path: 'external/internal',
    name: 'external-internal',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/audit-intern' },
    meta: { title: 'Intern' },
  },

  // LZP
  {
    path: 'lzp/clients',
    name: 'lzp-clients',
    component: LegacyContentLoader,
    props: { url: '/auth/web/page/client-view' },
    meta: { title: 'Alle klanten' },
  },
  {
    path: 'lzp/clients/:uuid',
    name: 'lzp-client-details',
    component: LegacyContentLoader,
    props: { url: '/auth/web/page/setup-client' },
    meta: { title: 'Klant beheer', breadcrumbParent: 'lzp-clients' },
  },
  {
    path: 'lzp/administration',
    name: 'lzp-administration',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/administration/administration' },
    meta: { title: 'Intern' },
  },
  {
    path: 'lzp/switcher',
    name: 'lzp-switcher',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/org-switcher' },
    meta: { title: 'Organization Switcher' },
  },

  // Handhaving
  {
    path: 'handhaving/departed-journeys',
    name: 'handhaving-departed-journeys',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/vertrokken-vracht' },
    meta: { title: 'Vertrokken vrachten' },
  },
  {
    path: 'handhaving/final-journeys',
    name: 'handhaving-final-journeys',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/finale-vrachten' },
    meta: { title: 'Finale vrachten' },
  },
  // other
  {
    path: 'project/details/:uuid/:type',
    name: 'project-details-legacy',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/projectv2' },
    meta: {
      title: 'Project',
      dynamicTitle: true,
      breadcrumbParent: (route: RouteLocationNormalizedLoaded) => {
        switch (route.params['type']) {
          case 'ECMR':
            return 'active-ecmr-projects'
          case 'IDF':
            return 'active-projects-deellocatie'
          default:
            return 'active-projects'
        }
      },
    },
  },
  {
    path: 'project/legacy-details/:uuid',
    name: 'project-legacy-details-deellocatie',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/project-deellocatie' },
    meta: {
      title: 'Project',
      breadcrumbParent: 'active-projects-deellocatie',
      dynamicTitle: true,
    },
  },
  {
    path: 'project/legacy-details/lite/:uuid',
    name: 'project-legacy-details-lite',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/project-lite' },
    meta: {
      title: 'Project',
      breadcrumbParent: 'active-projects-lite',
      dynamicTitle: true,
    },
  },
  {
    path: 'project/legacy-details/project-no-product-idf/:uuid',
    name: 'project-legacy-details-no-product-idf',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/project-no-product-idf' },
    meta: {
      title: 'Project',
      breadcrumbParent: 'active-projects-no-product-idf',
      dynamicTitle: true,
    },
  },
  {
    path: 'project/legacy-details/project-no-product-idf-grondbank/:uuid',
    name: 'project-legacy-details-no-product-idf-grondbank',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/project-no-product-idf-grondbank' },
    meta: {
      title: 'Project',
      breadcrumbParent: 'active-projects-no-product-idf-grondbank',
      dynamicTitle: true,
    },
  },
  {
    path: 'project/legacy-details/project-no-vervoerder-idf-grondbank/:uuid',
    name: 'project-legacy-details-no-vervoerder-idf-grondbank',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/project-no-product-idf-grondbank' },
    meta: {
      title: 'Project',
      breadcrumbParent: 'active-projects-no-vervoerder-idf-grondbank',
      dynamicTitle: true,
    },
  },
  {
    path: 'project/legacy-details/project-schip/:uuid',
    name: 'project-legacy-details-schip',
    component: LegacyContentLoader,
    props: { url: '/idf/web/page/schip-project' },
    meta: {
      title: 'Project',
      breadcrumbParent: 'active-projects-schip',
      dynamicTitle: true,
    },
  },
]

const routes: RouteRecordRaw[] = [
  {
    path: '/qr-check/:paramsonlyuuid',
    component: LegacyContentLoader,
    meta: {
      requiresAuth: false,
    },
    props: { url: '/afvalstroom/web/qrcheck' },
  },
  {
    path: '/afvalstroom/web/qrcheck',
    component: { render: () => null },
    beforeEnter(to: RouteLocationNormalizedGeneric) {
      const uuid = to.query['uuid']

      return `/qr-check/${uuid}`
    },
  },
  {
    path: '/login',
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/change-password',
    component: ChangePassword,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/oauth2',
    component: { render: () => null },
    beforeEnter() {
      window.location.href = import.meta.env['VITE_LEGACY_API'] + '/oauth2'
    },
  },
  {
    path: '/web/page/sso-process-login',
    component: ProcessSsoLogin,
  },
  {
    path: '/app',
    component: AppFallback,
  },
  {
    path: '/nl-app',
    component: AppFallbackNL,
  },
  {
    path: '/be-app',
    component: AppFallbackBE,
  },

  {
    path: '/home',
    component: LegacyMain,
    children: legacyRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/projects',
        name: 'project-list',
        component: ProjectList,
        meta: { title: 'Nest Project list' },
      },
      {
        path: '/projects/:uuid/details',
        name: 'project-details',
        component: ProjectDetails,
        meta: { title: 'Nest Project details', breadcrumbParent: 'project-list' },
      },

      {
        path: '/templates/new/:projectId',
        name: 'template-new-project',
        component: ShipmentTemplate,
        meta: { title: 'Nieuwe template', breadcrumbParent: 'template-overview' },
      },

      {
        path: '/templates',
        name: 'template-overview',
        component: ShipmentTemplateOverview,
        meta: { title: 'Templates Overview' },
      },

      {
        path: '/templates/:templateId',
        name: 'template-edit',
        component: ShipmentTemplate,
        meta: { title: 'Template bewerken', breadcrumbParent: 'template-overview' },
      },

      {
        path: '/templates/new',
        name: 'template-new',
        component: ShipmentTemplate,
        meta: { title: 'Nieuwe template', breadcrumbParent: 'template-overview' },
      },

      {
        path: '/shipments',
        name: 'shipment-overview',
        component: ShipmentOverview,
        meta: { title: 'Shipment Overview' },
      },

      {
        path: '/customer',
        name: 'customer',
        component: Customer,
        meta: { title: 'Customer' },
      },
      {
        path: '/users',
        name: 'users',
        component: UsersOverview,
        meta: { title: 'Users' },
      },
      {
        path: '/users/:id',
        name: 'user-details',
        component: UserDetails,
        meta: { title: 'User Details', breadcrumbParent: 'users' },
      },
      {
        path: '/organisations',
        name: 'control-organisation',
        component: OrganisationOverview,
        meta: { title: 'Organisations' },
      },
      {
        path: '/organisations/:id/details',
        name: 'organisation-details',
        component: OrganisationDetails,
        meta: { title: 'Organisatie details', breadcrumbParent: 'organisation' },
      },

      {
        path: '/sub-apps',
        name: 'form-wizard-root',
        meta: { requiresAuth: true, title: 'Sub Apps' },
        children: [
          {
            path: '',
            name: 'subApps',
            component: SubAppList,
            meta: { title: 'Sub Apps', breadcrumbParent: 'form-wizard-root' },
          },
          {
            path: ':subAppId/details',
            name: 'sub-app-details',
            component: SubAppDetails,
            meta: { title: 'Details', breadcrumbParent: 'subApps' },
          },
          {
            path: ':subAppId/details/flow/:type',
            name: 'configurator',
            component: FormWizard,
            meta: {
              title: (route: RouteLocationNormalizedLoaded) =>
                `Configurator (${route.params['type']})`,
              breadcrumbParent: 'sub-app-details',
            },
          },
        ],
      },
    ],
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.onError(routerErrorHandler)

router.beforeEach(to => {
  const requiresAuth = to.matched.some(record => record.meta['requiresAuth'])

  if (!requiresAuth) return true

  if (validateSession()) return true

  return {
    path: '/login',
    query: { redirect: to.fullPath !== '/' ? to.fullPath : undefined },
  }
})

export class LegacyRouter {
  public currentPageVal: string | undefined

  currentPage() {
    throw new Error('Deprecated')
  }

  public async getPage() {
    throw new Error('Deprecated')
  }

  goToPage() {
    this.currentPage()
  }
}

export default router
